import { useState, useEffect, useCallback } from 'react';
import '../pages/DashboardPage.css';

function AdminDocumentsPage() {
    const [documents, setDocuments] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [actionLoading, setActionLoading] = useState(null);
    const [filterUser, setFilterUser] = useState('');
    const API_URL = process.env.REACT_APP_API_URL || '';

    const fetchAllDocuments = useCallback(() => {
        setIsLoading(true);
        const session = JSON.parse(localStorage.getItem('userSession'));
        const role = session?.role || 'admin';

        fetch(`${API_URL}/api/admin/documents/all?requestingUserRole=${role}`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setDocuments(data.documents);
                }
            })
            .catch(err => console.error('Error fetching admin docs:', err))
            .finally(() => setIsLoading(false));
    }, [API_URL]);

    useEffect(() => {
        fetchAllDocuments();
    }, [fetchAllDocuments]);

    const handleDelete = async (docId) => {
        if (!window.confirm('Are you sure you want to delete this document from S3 and Database? This cannot be undone.')) return;

        const session = JSON.parse(localStorage.getItem('userSession'));
        setActionLoading(docId);

        try {
            const res = await fetch(`${API_URL}/api/documents/${docId}?requestingUserId=${session.userId}&requestingUserRole=${session.role}`, {
                method: 'DELETE'
            });
            const data = await res.json();
            if (data.success) {
                alert('Document deleted successfully');
                fetchAllDocuments();
            } else {
                alert(data.message || 'Delete failed');
            }
        } catch (err) {
            alert('Error deleting document');
        } finally {
            setActionLoading(null);
        }
    };



    const filteredDocs = documents.filter(doc =>
        doc.userName.toLowerCase().includes(filterUser.toLowerCase()) ||
        doc.email.toLowerCase().includes(filterUser.toLowerCase())
    );

    return (
        <div className="dashboard-page-new">
            <div className="welcome-section">
                <div>
                    <h1>Document Management 📂</h1>
                    <p className="welcome-subtitle">Manage all user uploads and S3 storage</p>
                </div>
            </div>

            <div className="content-section">
                <div className="section-header-new">
                    <div style={{ display: 'flex', gap: '1rem', width: '100%' }}>
                        <input
                            type="text"
                            placeholder="Search by User Name or Email..."
                            className="form-control"
                            style={{ flex: 1, padding: '12px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.05)', color: 'white' }}
                            value={filterUser}
                            onChange={(e) => setFilterUser(e.target.value)}
                        />
                        <button className="btn-secondary" onClick={fetchAllDocuments}>🔄 Refresh</button>
                    </div>
                </div>

                {isLoading ? (
                    <div style={{ textAlign: 'center', padding: '3rem' }}>Loading documents...</div>
                ) : (
                    <div className="documents-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '1.5rem', marginTop: '1.5rem' }}>
                        {filteredDocs.map(doc => (
                            <div key={doc.id} className="loan-card-new" style={{ padding: '1.25rem' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
                                    <div>
                                        <h3 style={{ margin: 0, fontSize: '1.1rem' }}>{doc.document_type}</h3>
                                        <p style={{ margin: '4px 0', fontSize: '0.85rem', color: '#fcc201' }}>User: {doc.userName}</p>
                                    </div>
                                    <span className={`status-badge ${doc.verification_status.toLowerCase()}`}>
                                        {doc.verification_status}
                                    </span>
                                </div>

                                <div style={{ fontSize: '0.85rem', color: '#888', marginBottom: '1rem' }}>
                                    <div>📧 {doc.email}</div>
                                    <div>📁 {doc.file_path}</div>
                                    <div>⏰ {new Date(doc.uploaded_at).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}</div>
                                </div>

                                <div style={{ display: 'flex', gap: '0.5rem' }}>
                                    <a
                                        href={doc.signed_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn-primary"
                                        style={{ flex: 1, textAlign: 'center', textDecoration: 'none', fontSize: '0.85rem' }}
                                    >
                                        View
                                    </a>

                                    <button
                                        className="btn-secondary"
                                        style={{ flex: 1, background: '#ef4444', border: 'none', color: 'white', fontSize: '0.85rem' }}
                                        onClick={() => handleDelete(doc.id)}
                                        disabled={actionLoading === doc.id}
                                    >
                                        {actionLoading === doc.id ? '...' : 'Delete'}
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>


        </div>
    );
}

export default AdminDocumentsPage;
